<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
    </div>

    <!-- Content Row -->
    <div class="row">
      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <router-link class="routerLink" to="/admin/order">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div
                    class="text-xs font-weight-bold text-primary text-uppercase mb-1"
                  >
                    Total Order
                  </div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">
                    {{ orders.length }}
                  </div>
                </div>
                <div class="col-auto">
                  <i class="fa fa-shopping-cart fa-2x text-gray-300"></i>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body">
            <router-link
              class="routerLink"
              :to="'/vendor/' + vendorId + '/products'"
            >
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div
                    class="text-xs font-weight-bold text-success text-uppercase mb-1"
                  >
                    Total Products
                  </div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">
                    {{ products.length }}
                  </div>
                </div>
                <div class="col-auto">
                  <i class="fa fa-fw fa-qq fa-2x text-gray-300"></i>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-info shadow h-100 py-2">
          <div class="card-body">
            <router-link class="routerLink" :to="'/admin/customerlist'">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div
                    class="text-xs font-weight-bold text-info text-uppercase mb-1"
                  >
                    Total Customer
                  </div>
                  <div class="row no-gutters align-items-center">
                    <div class="col-auto">
                      <div class="h5 mb-0 font-weight-bold text-gray-800">
                        {{ customer.length }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <i class="fa fa-user fa-2x text-gray-300"></i>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>

      <!-- Pending Requests Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2">
          <div class="card-body">
            <router-link
              class="routerLink"
              :to="'/vendor/' + vendorId + '/order'"
            >
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div
                    class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                  >
                    Pending Orders
                  </div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">
                    {{ pendingOrderCount }}
                  </div>
                </div>
                <div class="col-auto">
                  <i class="fa fa-shopping-cart fa-2x text-gray-300"></i>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->

    <div class="row">
      <!-- Area Chart -->
      <div class="col-xl-7 col-lg-7">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div
            class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
          >
            <h6 class="m-0 font-weight-bold text-primary">Pending Orders</h6>
          </div>
          <!-- Card Body -->
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date & Time</th>
                    <th>Name</th>
                    <th>Products</th>
                    <th>Total Ammount</th>
                  </tr>
                </thead>
                <tbody v-if="AllOrders.data">
                  <tr
                    v-for="(ord, orderindex) in AllOrders.data"
                    :key="orderindex"
                  >
                    <td>{{ ++orderindex }}</td>
                    <td>
                      {{
                        new Date(ord.createdAt * 1000).toLocaleDateString(
                          "en-us",
                          {
                            month: "short",
                            day: "numeric",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit"
                          }
                        )
                      }}
                    </td>
                    <td>
                      {{
                        ord.name
                          ? ord.name + "  " + ord.number
                          : "" + "  " + ord.number
                      }}
                    </td>
                    <td>
                      <b-btn
                        v-b-toggle="'order' + orderindex"
                        class="form-control btn btn-warning"
                      >
                        Bucket
                      </b-btn>
                      <b-collapse v-bind:id="'order' + orderindex" class="pt-2">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Qty</th>
                              <th>Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(buk, i) in ord.product" :key="i">
                              <td>{{ ++i }}</td>
                              <td>{{ buk.name }}</td>
                              <td>{{ buk.qty + " " + buk.unitType }}</td>
                              <td>{{ buk.price }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </b-collapse>
                    </td>
                    <td>{{ ord.delveryCharges + ord.orderAmount }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Pie Chart -->
      <div class="col-xl-5 col-lg-5">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div
            class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
          >
            <h6 class="m-0 font-weight-bold text-primary">Low Product Stock</h6>
          </div>
          <!-- Card Body -->
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="dataTable2"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Stock</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(product, index) in vendorProducts" :key="index">
                    <td>{{ ++index }}</td>
                    <td>{{ getProduct(product.productsId, "name") }}</td>
                    <td>{{ product.stock }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const $ = window.$;
import { dbFs } from "@/modules/database";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      orders: [],
      loading: false,
      customer: [],
      products: [],
      buckets: [],
      totalOrder: 0,
      pendingOrderCount: 0,
      pendingOrder: [],
      vendorProducts: [],
      dataTable: null,
      dataTable2: null
    };
  },
  mounted() {
    this.setupFirebaseReading();
    this.getBucketData();
  },
  computed: {
    ...mapGetters({
      vendorId: "getVendorId",
      AllOrders: "getOrders"
    }),
    ...mapActions({
      getOrders: "setOrder"
    })
    // filterOrders() {
    //   return this.AllOrders.data.filter(ord => (
    //     ord.product.currentStatus.type === "0"
    //   ))
    // }
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind("orders", dbFs.collection("order").limit(20));
      this.$bind("customer", dbFs.collection("customer"));
      this.$bind(
        "vendorProducts",
        dbFs
          .collection("vendorProducts")
          // .where("status", "==", true)
          .where("stock", "<", 5)
        // .limit(7)
      );
      this.$bind("products", dbFs.collection("products"))
        .catch(error => {
          this.loading = false;
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.PendingOrder();
          this.forDataTable();
        });
    },
    getLastOrderStatus(status) {
      let lastarr = status.slice(-1)[0];
      return [lastarr];
    },
    PendingOrder() {
      this.pendingOrder = [];
      let count = 0;
      this.orders.forEach(order => {
        let status = this.getLastOrderStatus(order.status);
        if (status[0].type == 0) {
          this.pendingOrder.push(order);
          ++count;
        }
      });
      this.pendingOrderCount = count;
    },
    forDataTable() {
      this.dataTable = $("#dataTable").DataTable({
        lengthMenu: [5, 10]
      });
      this.dataTable2 = $("#dataTable2").DataTable({
        lengthMenu: [5, 10]
      });
    },
    getProduct(id, dataType) {
      let productDetails = {
        name: "Not Found",
        unitType: "",
        image: ""
      };
      for (const cusKey of Object.keys(this.products)) {
        const product = this.products[cusKey];
        if (id == product.id) {
          productDetails = product;
        }
      }
      if (dataType == "name") {
        return productDetails.name;
      }
      if (dataType == "unitType") {
        return productDetails.unitType;
      }
      if (dataType == "image") {
        return productDetails.image;
      }
    },
    getCustomer(id, dataType) {
      let personalDetails = {
        name: "Not Available",
        number: "Not found",
        email: ""
      };
      for (const cusKey of Object.keys(this.customer)) {
        const customer = this.customer[cusKey];
        if (id == customer.id) {
          personalDetails = customer;
        }
      }
      if (dataType == "name") {
        return personalDetails.name;
      }
      if (dataType == "email") {
        return personalDetails.email;
      } else {
        return personalDetails.number;
      }
    },
    getBucketData() {
      this.loading = true;
      this.$bind("buckets", dbFs.collection("bucket"))
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBucket(id, dataType) {
      let bucketData = {};
      for (const cusKey of Object.keys(this.buckets)) {
        const bucket = this.buckets[cusKey];
        if (id == bucket.id) {
          bucketData = bucket;
        }
      }
      if (dataType == "all") {
        return bucketData;
      }
      if (dataType == "total") {
        let total = 0;
        if (bucketData.product) {
          for (const buck of bucketData.product) {
            let amount = buck.price;
            total += amount;
          }
        }
        return total + 50;
      }
    }
  },
  watch: {
    orders() {
      this.PendingOrder();
    },
    venderId() {
      this.getOrders();
    }
  }
};
</script>

<style>
.routerLink {
  text-decoration: none !important;
}
</style>
